import {
  FormControl,
  InputLabel,
  ListSubheader,
  MenuItem,
  Select
} from '@material-ui/core';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setFont } from '../../store/actions';
import { getFont } from '../../store/selectors';

export default function ChineseFontDropdown() {
  const dispatch = useDispatch();
  const font = useSelector(getFont);

  return (
    <FormControl>
      <InputLabel id="demo-simple-select-placeholder-label-label" shrink>
        Font
      </InputLabel>
      <Select
        id="demo-simple-select-placeholder-label"
        labelId="demo-simple-select-placeholder-label-label"
        onChange={(event) => {
          dispatch(setFont(event.target.value));
        }}
        value={font}
      >
        <MenuItem value="Dosis">Dosis (字獨/字独)</MenuItem>
        <ListSubheader disableSticky>Traditional</ListSubheader>
        <MenuItem style={{ fontFamily : 'Noto Sans TC, sans-serif' }} value="Noto Sans TC">Noto Sans TC (字獨)</MenuItem>
        <MenuItem style={{ fontFamily : 'Noto Serif TC, sans-serif' }} value="Noto Serif TC">Noto Serif TC (字獨)</MenuItem>
        <MenuItem style={{ fontFamily : 'WangFont011, sans-serif' }} value="WangFont011">WangFont011 (字獨)</MenuItem>
        <MenuItem style={{ fontFamily : 'WangFont021, sans-serif' }} value="WangFont021">WangFont021 (字獨)</MenuItem>
        <MenuItem style={{ fontFamily : 'WangFont028, sans-serif' }} value="WangFont028">WangFont028 (字獨)</MenuItem>
        <MenuItem style={{ fontFamily : 'WangFont034, sans-serif' }} value="WangFont034">WangFont034 (字獨)</MenuItem>
        <MenuItem style={{ fontFamily : 'WangFont064, sans-serif' }} value="WangFont064">WangFont064 (字獨)</MenuItem>
        <MenuItem style={{ fontFamily : 'WangFont071, sans-serif' }} value="WangFont071">WangFont071 (字獨)</MenuItem>
        <ListSubheader disableSticky>Simplified</ListSubheader>
        <MenuItem style={{ fontFamily : 'Long Cang, sans-serif' }} value="Long Cang">Long Cang (字独)</MenuItem>
        <MenuItem style={{ fontFamily : 'Liu Jian Mao Cao, sans-serif' }} value="Liu Jian Mao Cao">Liu Jian Mao Cao (字独)</MenuItem>
        <MenuItem style={{ fontFamily : 'Ma Shan Zheng, sans-serif' }} value="Ma Shan Zheng">Ma Shan Zheng (字独)</MenuItem>
        <MenuItem style={{ fontFamily : 'Noto Sans SC, sans-serif' }} value="Noto Sans SC">Noto Sans SC (字独)</MenuItem>
        <MenuItem style={{ fontFamily : 'Noto Serif SC, sans-serif' }} value="Noto Serif SC">Noto Serif SC (字独)</MenuItem>
        <MenuItem style={{ fontFamily : 'ZCOOL KuaiLe, sans-serif' }} value="ZCOOL KuaiLe">ZCOOL KuaiLe (字独)</MenuItem>
        <MenuItem style={{ fontFamily : 'ZCOOL XiaoWei, sans-serif' }} value="ZCOOL XiaoWei">ZCOOL XiaoWei (字独)</MenuItem>
        <MenuItem style={{ fontFamily : 'Zhi Mang Xing, sans-serif' }} value="Zhi Mang Xing">Zhi Mang Xing (字独)</MenuItem>
      </Select>
    </FormControl>
  );
}
